import { NavLink } from 'react-router';
import { Place } from 'shared/topchef.types';


export interface BriefsMarketMenuProps {
  loggedInPlace: Place
}

const BriefsMarketMenu = (props: BriefsMarketMenuProps) => {

  return (
    <ul id="briefsTabs" className="nav nav-underline" style={{marginBottom: 20}}>
      <li className="nav-item" role="presentation">
        <NavLink to="/places/shared-leads" className="nav-link" id="briefs_sended_tab"  type="button"  aria-controls="briefs_sended" >
          Briefs transmis
        </NavLink>
      </li>
      <li className="nav-item" role="presentation">
        <NavLink to="/places/available-leads" className="nav-link" id="briefs_available_tab"  type="button"  aria-controls="briefs_available" >
          Briefs disponibles
        </NavLink>
      </li>
      {props.loggedInPlace.acceptReward && 
      <>
        <li className="nav-item" role="presentation">
          <NavLink to="/places/leads/followed" className="nav-link" id="briefs_in_progress_tab"  type="button"  aria-controls="briefs_in_progress_tab" >
          Briefs à traiter
          </NavLink>
        </li>
        <li className="nav-item" role="presentation">
          <NavLink to="/places/leads/to-close" className="nav-link" id="briefs_to_close_tab"  type="button"  aria-controls="briefs_to_close_tab" >
          Briefs signés à clôturer
          </NavLink>
        </li>
      </>}
      {props.loggedInPlace.acceptReward ===false &&
      <li className="nav-item" role="presentation">
        <NavLink to="/places/leads/followed" className="nav-link" id="briefs_in_progress_tab"  type="button"  aria-controls="briefs_in_progress_tab" >
        Briefs suivis
        </NavLink>
      </li>
      } 

    </ul>
  );

}

export default BriefsMarketMenu;
